///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq = abcsetup.rfq || {};
abcsetup.rfq.bid_requests = abcsetup.rfq.bid_requests || {};
abcsetup.rfq.bid_requests.create_market = abcsetup.rfq.bid_requests.create_market || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq.bid_requests.create_market = {
    init: function () {
        abcsetup.setTitle('Add RFQ Event');

        // Init the common lib
        abcsetup.rfq.bid_requests.common.init();

        // Auto-select "Supply Issues" bid type after we select formulary type, if we're creating this RFQ Event for a supply issue.
        // The showIfs are running after this onchange event in my browser.
        // This means we don't know which "Supply Issue" bid type we should select when this runs.
        // So, we're crossing our fingers that the showifs will be done after a certain amount of time and we will then select the correct one for the current formulary type.
        let hackyAutoSelectSupplyIssueTimeoutID;
        let hackyAutoSelectSupplyIssueWaitMs = 500;
        $('#formulary_type').on('change', () => {
            window.clearTimeout(hackyAutoSelectSupplyIssueTimeoutID);
            const BidTypeSelect = $('#rfq_bid_type_id').trigger('change');

            // Reset the bid type dropdown if the option is no longer available
            setTimeout(function() {
                if ($('#rfq_bid_type_id').val() && BidTypeSelect.find('option[value="' + $('#rfq_bid_type_id').val() + '"]').hasClass('showIfHide')) {
                    BidTypeSelect.val(null);
                }
            }, 500);

            const for_supply_issue = String($('[name=rfq_supply_issue_ids]').first().val() || '').length > 0;
            if (for_supply_issue) {
                window.setTimeout(() => {
                    const supply_issue_id = BidTypeSelect.find('option:not(.showIfHide):contains("Supply Issues")').first().attr('value');
                    BidTypeSelect.val(supply_issue_id).trigger('change');
                }, hackyAutoSelectSupplyIssueWaitMs);
            }
        });

        // Start date was changed
        $('#start_date').bind('change', function () {
            if (abcsetup.userRole && abcsetup.userRole.class=='abc_swiss'){
                $('#close_date').val(moment($(this).val(), 'YYYY-MM-DD').add(11,'days').format('YYYY-MM-DD'));
            } else {
                $('#close_date').val(momentBusinessDays($(this).val(), 'YYYY-MM-DD').businessAdd(3).format('YYYY-MM-DD'));
            }
        });

        // Adjust the min date based on value
        if ($('#start_date').val() > $('#start_date').attr('min')) {
            $('#start_date').attr('min', $('#start_date').val());
        }

        // Bid type changed
        $('#gcn_family, #rfq_bid_type_id, #start_date').bind('change', function () {

            if ($(this).val() != '') {
                if ($('#gcn_family').val() != '' && $('#rfq_bid_type_id').val() != '') {
                    var name = $("#rfq_bid_type_id option:selected").text() + ' :: ' + $('#gcn_family').val() + ' - ' + $('#start_date').val();
                    $('#name').val(name);
                }
            }
        });
    },

    /**
     * _jquery.fieldLib
     *      Fields have been init - this is the callback
     */
    fieldsInit: function () {
        $('#all_suppliers, #rfq_bid_type_id').trigger('change');
    },

    /**
     * _jquery.uploader
     *      An upload is complete this is the callback
     */
    uploadDone: function () {
        // Import the specified items
        if (abcsetup.uploader.uploadResult.type === 'items') {
            abcsetup.rfq.bid_requests.common.importItems(abcsetup.uploader.uploadResult.vals);
        } else {
            abcsetup.rfq.bid_requests.common.importSuppliers(abcsetup.uploader.uploadResult.vals);
        }
    },
}
